var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, Grid, IconButton, Skeleton, Stack, Typography } from "@mui/material";
import { useCurrencyLocalizer } from "../../hooks/useCurrencyLocalizer";
// Left side typography component
export const LeftSideTypography = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(Typography, Object.assign({ variant: "body2", flexGrow: 1 }, rest, { children: children })));
};
// Right side typography component
export const RightSideTypography = (_a) => {
    var { children, loading } = _a, rest = __rest(_a, ["children", "loading"]);
    return loading ? (_jsx(Skeleton, Object.assign({ variant: "text" }, { children: _jsx(Typography, Object.assign({ variant: "body2" }, { children: children })) }))) : (_jsx(Typography, Object.assign({ variant: "body2", textAlign: "end" }, rest, { children: children })));
};
// Full order summary item component
export const OrderSummaryLine = ({ label, value, indent = false, bold = false, loading = false }) => {
    const { localizedCurrencyText, isCredit } = useCurrencyLocalizer(value, true);
    const text = isCredit ? "-" : "";
    return (_jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsxs(Stack, Object.assign({ direction: "row" }, { children: [_jsx(LeftSideTypography, Object.assign({ sx: { pl: indent ? 2 : 0, fontWeight: bold ? "bold" : "normal" } }, { children: label })), _jsx(RightSideTypography, Object.assign({ loading: loading }, { children: `${text}${localizedCurrencyText}` }))] })) })));
};
/**
 * Renders a grid item that displays a label and value.
 * It also includes a toggle icon that allows the user to expand or collapse additional information.
 *
 * @param {React.ReactNode} props.label - The label text or element to display on the left side.
 * @param {string | undefined} props.value - The value text to display on the right side.
 * @param {function} props.onChange - Callback function that gets called when the expand/collapse button is clicked.
 * @param {boolean} props.open - A boolean indicating whether the section is expanded (true) or collapsed (false).
 */
export const CollapsibleOrderSummaryLine = ({ label, value, onChange, open, loading = false }) => {
    return (_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center" }, { children: [_jsx(LeftSideTypography, { children: label }), _jsx(IconButton, Object.assign({ size: "small", onClick: onChange }, { children: open ? _jsx(ExpandLessIcon, { fontSize: "inherit" }) : _jsx(ExpandMoreIcon, { fontSize: "inherit" }) }))] })), value ? _jsx(RightSideTypography, Object.assign({ loading: loading }, { children: value })) : null] })) })));
};
export const OrderSummaryDivider = () => _jsx(Divider, { style: { margin: "0.5rem 0" } });
